/**
 * Tests for the presence of a given widget in the current page.
 *
 * @param regex The regular expression object used to test against each widget on the page
 * @returns {boolean} true if the specified widget is present; false otherwise
 */
const widgetIsPresent = (regex, pageWidgets) =>
	pageWidgets?.find?.((pageWidget) => regex.test(pageWidget)) !== undefined;

export default widgetIsPresent;
